import React, { useState } from "react";
import {
  Grid,
  AppBar,
  Toolbar,
  // Typography,
  Link,
  styled,
  Box,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { assetsObj } from "services/images";
import DrawerModel from "../menu-modal/drawer";

const HeaderContainer = styled("div")({
  alignItems: "center",
  marginBottom: 20,
});

const LinkContainer = styled("div")({
  display: "flex",
  alignItems: "center",
  // fontWeight: 600,
});

const HeadingContainer = styled("div")({
  display: "flex",
  flexDirection: "column",
  textAlign: "center",
});

const StyledLink = styled(Link)({
  marginInline: "5px",
  color: "white",
  paddingRight: "2px",
  textDecoration: "none",
  fontSize: "14px",
  fontWeight: 600,
});

const Header = () => {
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);

  const handleMenuClick = (event) => {
    setMenuAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
  };

  const open = Boolean(menuAnchorEl);

  return (
    <HeaderContainer>
      <AppBar
        position="static"
        sx={{ background: "transparent", boxShadow: "none" }}
      >
        <Toolbar
          sx={
            {
              // paddingLeft: "10px !important",
              // paddingRight: "10px !important",
            }
          }
        >
          <Grid
            container
            spacing={2}
            alignItems="center"
            justifyContent="space-between"
          >
            <Grid
              item
              xs={2}
              md={4}
              lg={4}
              sx={{
                paddingTop: "12px !important",
                paddingLeft: "8px !important",
              }}
            >
              <LinkContainer sx={{ display: { xs: "none", md: "flex" } }}>
                <StyledLink
                  component={'a'}
                  href="https://affirmate.app/#about-us"
                >
                  ABOUT
                </StyledLink>
                <StyledLink
                  component={'a'}
                  href="https://affirmate.app/#faq"
                >
                  FAQ
                </StyledLink>
                <StyledLink
                  component={'a'}
                  href="https://affirmate.app/#blog"
                >
                  BLOG
                </StyledLink>
                <StyledLink
                  component={'a'}
                  href="https://affirmate.app/#contact-us"
                >
                  CONTACT US
                </StyledLink>
              </LinkContainer>
            </Grid>

            <Grid item xs={8} md={4} lg={4}>
              <HeadingContainer
                sx={{
                  paddingTop: "7px",
                  // paddingRight: "9px",

                  "@media (max-width: 599px)": {
                    paddingTop: "2px",
                    // paddingRight: "1px",
                    paddingRight: "0px",
                  },
                }}
              >
                {/* <Typography
                  component={Link}
                  variant="body1"
                  href="https://affirmate.app/"
                  sx={{
                    textDecoration: "none",
                    color: "#FFFFFF",
                    fontWeight: 300,
                    fontSize: "28px",
                    marginBottom: "-9px",
                  }}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                </Typography> */}
                <Link href="https://affirmate.app/" style={{
                  textDecoration: "none",
                    color: "#FFFFFF",
                    fontWeight: 300,
                    fontSize: "28px",
                    marginBottom: "-9px",
                }}>
                  AFFIRMATE

                </Link>
                <Link
                  // component={Link}
                  // variant="body2"
                  href="https://affirmate.app/"
                  style={{
                    textDecoration: "none",
                    color: "#ffffffe6",
                    lineHeight: 1.77143,
                    fontWeight: 200,
                    fontSize: "18px",
                    wordWrap: "nowrap",
                    "@media (max-width: 334px)": {
                      fontSize: "17px",
                    },
                    "@media (max-width: 399px)": { lineHeight: 1.77143 },
                  }}
                  target="_blank"
                >
                  you are what you repeat
                </Link>
              </HeadingContainer>
            </Grid>

            <Grid item xs={2} md={4} lg={4} className="text-right">
              <Box
                component="img"
                src={assetsObj.menuIcon}
                sx={{
                  color: "white",
                  "&:hover": { background: "transparent" },
                  display: { xs: "inline-block", md: "none" },
                  zIndex: 1000,
                  paddingBottom: "10px",
                  position: "absolute",
                  right: "8px",
                  bottom: "31%",
                }}
                onClick={handleMenuClick}
              />

              {menuAnchorEl && (
                <DrawerModel setMenuAnchorEl={setMenuAnchorEl} />
              )}
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
    </HeaderContainer>
  );
};

export default Header;
